<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <span v-html="message">
                    </span>
                </div>
            </div>
<!--          <div @click="closeEvent()">-->
<!--            <bottom-button :buttonArray="buttonArray"></bottom-button>-->
<!--          </div>-->
          <div class="button-wrap">
            <button class="button-bg-gray" @click="closeEvent">닫기</button>
          </div>
        </div>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
    name: 'bottomPopup',
    components: {BottomButton},
    data() {
        return  {

        }
    },
    props: ['message'],
    methods : {
      closeEvent() {
            this.$emit('closeEvent', false);
        },
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/stopUsingCancelPopup.scss';
  @import '@/assets/styles/common/bottomButton.scss';
</style>